import { createContext, useContext } from 'react';

import { IMapConflictContext } from './interfaces';

export const MapConflictContext = createContext<IMapConflictContext | null>(
  null
);

export const useMapConflict = (): IMapConflictContext => {
  const ctx = useContext(MapConflictContext);
  if (!ctx) {
    throw new Error('useMapConflict must be used inside MapConflictProvider');
  }
  return ctx;
};
